import { createSlice } from '@reduxjs/toolkit';
import {
  STEP_NAME_START,
  STEP_NAME_HOME_DETAILS,
  STEP_NAME_ADDRESS_DETAILS,
  STEP_NAME_COVERS,
  STEP_NAME_SUMMARY
} from '../../pages/homeInsurancePages/newHomePolicy/data';

const initialState = {
  currentStepIndex: 0,
  currentSubstepIndex: 0,
  steps: [
    {
      name: STEP_NAME_START,
      substeps: ['basic_info', 'documents_ready'],
    },
    {
      name: STEP_NAME_HOME_DETAILS,
      substeps: ['home_info'],
    },
    {
      name: STEP_NAME_ADDRESS_DETAILS,
      substeps: ['address_info'],
    },
    {
      name: STEP_NAME_COVERS,
      substeps: ['coverage_selection'],
    },
    {
      name: STEP_NAME_SUMMARY,
      substeps: ['review_summary', 'payment_methods'],
    },
  ],
};

const homeFlowSlice = createSlice({
  name: 'homeFlow',
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStepIndex < state.steps.length - 1) {
        state.currentStepIndex += 1;
        state.currentSubstepIndex = 0;
      }
    },
    prevStep: (state) => {
      if (state.currentStepIndex > 0) {
        state.currentStepIndex -= 1;
        state.currentSubstepIndex = state.steps[state.currentStepIndex].substeps.length - 1;
      }
    },
    nextSubstep: (state) => {
      const currentStep = state.steps[state.currentStepIndex];
      if (state.currentSubstepIndex < currentStep.substeps.length - 1) {
        state.currentSubstepIndex += 1;
      } else if (state.currentStepIndex < state.steps.length - 1) {
        state.currentStepIndex += 1;
        state.currentSubstepIndex = 0;
      }
    },
    prevSubstep: (state) => {
      if (state.currentSubstepIndex > 0) {
        state.currentSubstepIndex -= 1;
      } else if (state.currentStepIndex > 0) {
        state.currentStepIndex -= 1;
        state.currentSubstepIndex = state.steps[state.currentStepIndex].substeps.length - 1;
      }
    },
    goToStep: (state, action) => {
      const { stepIndex, substepIndex = 0 } = action.payload;
      if (stepIndex >= 0 && stepIndex < state.steps.length) {
        state.currentStepIndex = stepIndex;
        state.currentSubstepIndex = substepIndex;
      }
    },
    goToSubstep: (state, action) => {
      const { substepIndex } = action.payload;
      const currentStep = state.steps[state.currentStepIndex];
      if (substepIndex >= 0 && substepIndex < currentStep.substeps.length) {
        state.currentSubstepIndex = substepIndex;
      }
    },
    resetHomeFlow: (state) => {
      return initialState;
    },
  },
});

export const {
  nextStep,
  prevStep,
  nextSubstep,
  prevSubstep,
  goToStep,
  goToSubstep,
  resetHomeFlow,
} = homeFlowSlice.actions;

// Selectors
export const selectCurrentStep = (state) => state.homeFlow.steps[state.homeFlow.currentStepIndex];
export const selectCurrentSubstep = (state) => {
  const currentStep = state.homeFlow.steps[state.homeFlow.currentStepIndex];
  return currentStep.substeps[state.homeFlow.currentSubstepIndex];
};
export const selectCurrentStepIndex = (state) => state.homeFlow.currentStepIndex;
export const selectCurrentSubstepIndex = (state) => state.homeFlow.currentSubstepIndex;
export const selectAllSteps = (state) => state.homeFlow.steps;

export default homeFlowSlice.reducer;